import React, { useEffect, useState } from 'react';
import downloadIcon from "../../../Assets/icons/download.svg";
import './index.scss';
import { useNavigate } from 'react-router-dom';
import CustomTable from '../../customComponents/CustomTable';
import { FaPlus } from "react-icons/fa6";
import { USERROLE_KEY_MAPPING, USERROLE_TABLE_DATA, USERROLE_TABLE_HEADERS } from '../../../constants/LogisticsLists';
import ROUTES_NAVIGATION from '../../../routes/routes';
import axiosInstance from '../../services/api/API';
import Loader from '../../customComponents/CustomLoader';


const Logistics = () => {
  const [tableData, setTableData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const [totalData, setTotalData] = useState(0);
  const [totalActive, setTotalActive] = useState(0);
  const [totalInactive, setTotalInactive] = useState(0);
  const [BUSINESSPARTNERID,SETBUSINESSPRTNERID] = useState()

  const navigate = useNavigate();
  const token = localStorage.getItem('authToken');
  const business_partner_id = localStorage.getItem('business_partner_id');
  const USERTYPE = localStorage.getItem('UserType');
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    fetchLogisticData();
  }, []);

  const fetchLogisticData = async (page = 0, pageSize = 10, searchQuery = '') => {
    try {
      setLoading(true)
      const response = await axiosInstance.post(
        '/logistics/list',
        {
          orderBy: "logistic_id desc",
          page: page,
          pageSize: pageSize,
          business_partner_id:business_partner_id=="0"?null:business_partner_id,
          searchText: searchQuery // Add search query to the payload
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const formattedData = response?.data?.data?.data?.map((item, index) => ({
        ...item,
        'Sr No.': index + 1,
      }));

      const totalRecordsData = response?.data?.data?.totalRecords;
      setTotalRecords(totalRecordsData);
      SETBUSINESSPRTNERID(formattedData[0]?.business_partner_id)
      const totalCount = response?.data?.data?.total;
      const totalAct = response?.data?.data?.total_active;
      const totalInac = response?.data?.data?.total_inactive;
console.log("formatteddata",formattedData);

      setTotalData(totalCount);
      setTotalActive(totalAct);
      setTotalInactive(totalInac);

      setTableData(formattedData);
      setTotalPages(Math.ceil(totalRecordsData / pageSize));
    } catch (error) {
      console.error('Error fetching logistic list:', error);
    }
    finally{
      setLoading(false)
    }
  };
console.log("BUSINESSPARTNERID",BUSINESSPARTNERID);

  const createNavigation = () => {
    navigate("/manage-logistics/add-logistics");
  }

  const handleEditButton = (rowData) => {
    console.log("rowData>>",rowData);
    
    navigate(`${ROUTES_NAVIGATION.ADDLOGISTICS}`, { state: { data: rowData, isEdit: true } });
  }

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchLogisticData(newPage, 10, searchTerm); 
  };

  const handleSearchInput = (e) => {
    const value = e.target.value;
    setSearchTerm(value);

    if (value === '') {
      
      fetchLogisticData(0, 10, '');
    }
  }

  const handleKeyPress = (e) => {
    console.log("keyname",e.key);
    
    if (e.key === 'Enter') {
      fetchLogisticData(0, 10, searchTerm); 
    }
  }
  const filteredHeaders = USERTYPE === 'superadmin' ? USERROLE_TABLE_HEADERS : USERROLE_TABLE_HEADERS.filter(header => header !== 'Business Partner Name');
  const filteredKeyMapping = USERTYPE === 'superadmin' ? USERROLE_KEY_MAPPING : Object.fromEntries(Object.entries(USERROLE_KEY_MAPPING).filter(([key]) => key !== 'Business Partner Name'));

  return (
    <div>
       {loading ? ( 
        <Loader />
      ) : (
      <><div className='OnboardManagamentContainer'>
            <div className='OnboardManagamentbuttonContainer'>
              <h4>Logistics</h4>
            </div>

            <div className='CreateNewLogisticsBtn' onClick={createNavigation}>
              <FaPlus className='plusIcon' />
              <button className='addcustomerbutton' style={{ paddingLeft: "30px" }}>Create New</button>
            </div>
          </div><div className='tableWrapper'>
              <div className='admin-list-container'>
                <div className='listsearchContainer'>
                  <h5>All List</h5>
                  <input
                    type='text'
                    className='searchinput'
                    placeholder='Search by Vendor Name'
                    value={searchTerm}
                    onChange={handleSearchInput}
                    onKeyPress={handleKeyPress} />
                </div>
                {/* <div className='downloadiconwrapper'>
      <h6 className='downloadTitle'>Download</h6>
      <img src={downloadIcon} alt='download' />
    </div> */}
              </div>

              <CustomTable
                data={tableData}
                headers={filteredHeaders}
                keyMapping={filteredKeyMapping}
                itemsPerPage={10}
                onEdit={handleEditButton}
                totalPages={totalPages}
                totalRecords={totalRecords}
                currentPage={currentPage}
                onPageChange={handlePageChange} />
            </div></>
      )}
    </div>
  )
}

export default Logistics;
